import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const AWS = () => {
  return (
    <StartInterviewLayout type="aws"/>
  )
}

export default AWS;